// Model.js
// -----------------------
// @module Case
define("NVT.SSO_Mechanism.SSOMechanism.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/SSOMechanism/SuiteScript2/SSOMechanism.Service.ss"
            ),
            true
        )
});
});
